var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "m-title" },
    [
      _c("span", [_vm._v(_vm._s(_vm.titleText))]),
      _vm._v(" "),
      _c(
        "el-tooltip",
        {
          staticClass: "item",
          attrs: { effect: "light", content: _vm.tipText, placement: "top" }
        },
        [_vm.tipText ? _c("i", { staticClass: "el-icon-question" }) : _vm._e()]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6ab1ddfa", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6ab1ddfa","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/szrt_revision/new_account_settings/accountSettings/overallStatistics/components/mTitle.vue
// module id = null
// module chunks = 